import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { LoginDomainService } from '../../../domain/services/login/login.domain.service';
import { QuotaDomainService } from '../../../domain/services/quota/quota.domain.service';
import { TotalUserQuota } from '../../../domain/models/TotalUserQuota';

@Injectable()
export class HeaderService {

  constructor(private loginDomainService: LoginDomainService, private quotaDomainService: QuotaDomainService) { }

  getOauthInstance(): Observable<any> {
    return this.loginDomainService.getOauthInstance();
  }

  getTotalQuota(): Observable<{} | TotalUserQuota> {
    return this.quotaDomainService.getTotalQuota();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/header/header.service.ts